import isURL from 'validator/lib/isURL';
export const validate = (values) => {
    var _a, _b, _c;
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!((_a = values === null || values === void 0 ? void 0 : values.webhookName) === null || _a === void 0 ? void 0 : _a.trim())) {
        errors.webhookName = 'Please add a title';
    }
    if (!((_b = values === null || values === void 0 ? void 0 : values.webhookUrl) === null || _b === void 0 ? void 0 : _b.trim())) {
        errors.webhookUrl = 'Please add an url';
    }
    else if (!isURL(values.webhookUrl, {
        require_protocol: true,
        protocols: ['https'],
        require_valid_protocol: true,
    })) {
        errors.webhookUrl = 'Please write a valid https URL';
    }
    if (!(((_c = values === null || values === void 0 ? void 0 : values.subscriptionEvents) === null || _c === void 0 ? void 0 : _c.length) > 0)) {
        errors.subscriptionEvents =
            'You need to pick at least one event to subscribe to this webhook';
    }
    return errors;
};
export const toFormValue = (subscription) => ({
    id: subscription.id,
    webhookName: subscription.name,
    webhookUrl: subscription.url,
    subscriptionEvents: subscription.fqns,
    headers: subscription.user_supplied_headers,
    isEnabled: subscription.is_enabled,
});
export const toCreatePayload = ({ webhookName, subscriptionEvents, webhookUrl, headers, isEnabled, }) => {
    return {
        name: webhookName,
        fqns: subscriptionEvents,
        url: webhookUrl,
        user_supplied_headers: headers || {},
        is_enabled: isEnabled || false,
    };
};
export const toUpdatePayload = (payload) => (Object.assign(Object.assign({}, toCreatePayload(payload)), { id: payload.id }));
